import React from 'react';
import {ConfigList} from "components/config/ConfigList";
import {Provider} from "components/config/ConfigContext";

export const Configs = () => {

    return (
        <Provider>
            <ConfigList/>
        </Provider>
    );
}
